.field {
  display: flex;
  flex-direction: column;
}

/* 44px row so it is easy to hit on touch screens (DESIGN.md §10). */
.checkbox {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: var(--row-height);
  color: var(--ink);
  font: var(--t-body);
  cursor: pointer;
}

.box {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-tag);
  background: var(--paper);
  transition: background-color var(--dur) var(--ease);
}

/* A tick drawn with borders, so no icon font is needed. */
.tick {
  display: none;
  width: 6px;
  height: 11px;
  margin-top: -2px;
  border-right: 2px solid var(--on-brand);
  border-bottom: 2px solid var(--on-brand);
  transform: rotate(45deg);
}

.checkbox[data-selected] .box {
  border-color: var(--brand);
  background: var(--brand);
}

.checkbox[data-selected] .tick {
  display: block;
}

.checkbox[data-focus-visible] .box {
  outline: var(--focus-ring);
  outline-offset: var(--focus-offset);
}

.checkbox[data-disabled] {
  color: var(--pencil);
  cursor: not-allowed;
}

.checkbox[data-disabled] .box {
  border-color: var(--rule);
  background: var(--wash);
}

.description {
  padding-left: calc(20px + var(--space-3));
  color: var(--graphite);
  font: var(--t-small);
}

/* Errors are stated in words, in ink; danger red is reserved for clinical danger. */
.error {
  padding-left: calc(20px + var(--space-3));
  color: var(--status-error-fg);
  font: var(--t-small);
  font-weight: 600;
}
